import { InventoryItemAttributeValueDTO } from "./item-attribute-value";

export interface InventoryStatusDTO {
    id?: number;
    isActive?: boolean;
    updatedDate?: string;
    createdDate?: Date;
    createdBy?: string;
    createdByUserId?: number;
    name?: string;
    description?: string;
    isLocked?: boolean;
    isWarning?: boolean;
}

/** CSS modifier for a `.status-tag` (colours live in @theme/styles/shared/_page-shell.scss). */
export function inventoryStatusClass(status?: string): string {
    switch (status?.toLowerCase()) {
        case undefined:
        case '':
            return '';
        case 'available':
            return 'status-available';
        case 'hold':
            return 'status-hold';
        case 'overflow':
            return 'status-overflow';
        default:
            return 'status-default';
    }
}
